module.exports = __webpack_public_path__ + "static/media/CTLI_17-235w.562d75d6.webp";